// import React, { useEffect, useMemo, useState } from "react";
// import api from "../../api";
// import {
//   Table,
//   Button,
//   Modal,
//   Form,
//   InputGroup,
//   Pagination,
//   Spinner,
//   Badge,
// } from "react-bootstrap";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Select from "react-select";
// import Can from "../../components/Can";
// import "./SubCategory.css";

// const initialForm = {
//   name: "",
//   description: "",
//   unit_id: "",
//   category_id: "",
//   staff_ids: [],
//   tat_value: "",
//   tat_unit: "days",
// };

// export default function AdminSubCategoryPage() {
//   const [data, setData] = useState([]);
//   const [units, setUnits] = useState([]);
//   const [allCategories, setAllCategories] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [staffList, setStaffList] = useState([]);
//   const [filteredStaff, setFilteredStaff] = useState([]);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [deleteId, setDeleteId] = useState(null);

//   const [modalShow, setModalShow] = useState(false);
//   const [deleteModalShow, setDeleteModalShow] = useState(false);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterUnit, setFilterUnit] = useState("");
//   const [filterCategory, setFilterCategory] = useState("");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [sortField, setSortField] = useState("id");
//   const [sortOrder, setSortOrder] = useState("asc");

//   useEffect(() => {
//     fetchAll();
//   }, []);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterUnit, filterCategory, itemsPerPage]);

//   const fetchAll = async () => {
//     try {
//       setLoading(true);

//       const [unitsRes, catsRes, staffRes, subsRes] = await Promise.all([
//         api.get(`/units`),
//         api.get(`/categories`),
//         api.get(`/technician-users`),
//         api.get(`/subcategories`),
//       ]);

//       setUnits(Array.isArray(unitsRes.data) ? unitsRes.data : []);
//       setAllCategories(Array.isArray(catsRes.data) ? catsRes.data : []);
//       setStaffList(Array.isArray(staffRes.data) ? staffRes.data : []);
//       setData(Array.isArray(subsRes.data) ? subsRes.data : []);
//     } catch (error) {
//       console.error("Fetch Subcategory Error:", error);
//       toast.error("Failed to fetch data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const unitMap = useMemo(() => {
//     return Object.fromEntries(units.map((unit) => [String(unit.id), unit.name]));
//   }, [units]);

//   const categoryMap = useMemo(() => {
//     return Object.fromEntries(
//       allCategories.map((cat) => [String(cat.id), cat.name])
//     );
//   }, [allCategories]);

//   const categoryUnitMap = useMemo(() => {
//     return Object.fromEntries(
//       allCategories.map((cat) => [String(cat.id), cat.unit_id])
//     );
//   }, [allCategories]);

//   const filterCategoriesByUnit = (unitId) => {
//     const filtered = allCategories.filter(
//       (cat) => String(cat.unit_id) === String(unitId)
//     );
//     setCategories(filtered);
//   };

//   const filterStaffByUnit = (unitId) => {
//     const filtered = staffList.filter(
//       (user) => String(user.unit_id) === String(unitId)
//     );
//     setFilteredStaff(filtered);
//   };

//   const filteredData = useMemo(() => {
//     let list = [...data];

//     if (searchTerm.trim()) {
//       const q = searchTerm.toLowerCase();

//       list = list.filter((sub) => {
//         const staffNames = sub.staff?.map((s) => s.name).join(" ") || "";
//         const categoryName =
//           sub.category_name || categoryMap[String(sub.category_id)] || "";

//         return [
//           sub.id,
//           sub.name,
//           sub.description,
//           categoryName,
//           staffNames,
//           sub.tat_value,
//           sub.tat_unit,
//         ]
//           .map((value) => (value ?? "").toString().toLowerCase())
//           .join(" ")
//           .includes(q);
//       });
//     }

//     if (filterCategory) {
//       list = list.filter(
//         (sub) => String(sub.category_id) === String(filterCategory)
//       );
//     }

//     if (filterUnit) {
//       list = list.filter((sub) => {
//         const unitId =
//           sub.unit_id || categoryUnitMap[String(sub.category_id)] || "";
//         return String(unitId) === String(filterUnit);
//       });
//     }

//     list.sort((a, b) => {
//       let valueA = "";
//       let valueB = "";

//       if (sortField === "category") {
//         valueA = a.category_name || categoryMap[String(a.category_id)] || "";
//         valueB = b.category_name || categoryMap[String(b.category_id)] || "";
//       } else if (sortField === "tat") {
//         valueA = Number(a.tat_value || 0);
//         valueB = Number(b.tat_value || 0);
//       } else {
//         valueA = a[sortField] ?? "";
//         valueB = b[sortField] ?? "";
//       }

//       valueA = valueA.toString().toLowerCase();
//       valueB = valueB.toString().toLowerCase();

//       if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
//       if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
//       return 0;
//     });

//     return list;
//   }, [
//     data,
//     searchTerm,
//     filterUnit,
//     filterCategory,
//     categoryMap,
//     categoryUnitMap,
//     sortField,
//     sortOrder,
//   ]);

//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const indexOfLast = currentPage * itemsPerPage;
//   const indexOfFirst = indexOfLast - itemsPerPage;
//   const paginatedData = filteredData.slice(indexOfFirst, indexOfLast);

//   const handleChange = (field, value) => {
//     setForm((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const getSortIcon = (field) => {
//     if (sortField !== field) return "↕";
//     return sortOrder === "asc" ? "↑" : "↓";
//   };

//   const validateForm = () => {
//     if (!form.name.trim()) {
//       toast.warn("Subcategory name is required");
//       return false;
//     }

//     if (!form.unit_id) {
//       toast.warn("Please select unit");
//       return false;
//     }

//     if (!form.category_id) {
//       toast.warn("Please select category");
//       return false;
//     }

//     if (!form.staff_ids.length) {
//       toast.warn("Please select at least one staff");
//       return false;
//     }

//     if (!form.tat_value) {
//       toast.warn("Please enter turnaround time");
//       return false;
//     }

//     return true;
//   };

//   const openAddModal = () => {
//     setForm(initialForm);
//     setCategories([]);
//     setFilteredStaff([]);
//     setEditId(null);
//     setModalShow(true);
//   };

//   const handleEdit = (row) => {
//     const selectedCategory = allCategories.find(
//       (cat) => String(cat.id) === String(row.category_id)
//     );

//     const selectedUnitId =
//       row.unit_id || selectedCategory?.unit_id || "";

//     setForm({
//       name: row.name || "",
//       description: row.description || "",
//       unit_id: selectedUnitId,
//       category_id: row.category_id || "",
//       staff_ids: row.staff?.map((s) => String(s.id)) || [],
//       tat_value: row.tat_value || "",
//       tat_unit: row.tat_unit || "days",
//     });

//     filterCategoriesByUnit(selectedUnitId);
//     filterStaffByUnit(selectedUnitId);

//     setEditId(row.id);
//     setModalShow(true);
//   };

//   const resetForm = () => {
//     setForm(initialForm);
//     setCategories([]);
//     setFilteredStaff([]);
//     setEditId(null);
//     setModalShow(false);
//   };

//   const handleSave = async () => {
//     if (!validateForm()) return;

//     try {
//       setSaving(true);

//       const payload = {
//         name: form.name.trim(),
//         description: form.description.trim(),
//         unit_id: Number(form.unit_id),
//         category_id: Number(form.category_id),
//         staff_ids: form.staff_ids.map((id) => Number(id)),
//         tat_value: Number(form.tat_value),
//         tat_unit: form.tat_unit,
//       };

//       if (editId) {
//         await api.put(`/subcategories/${editId}`, payload);
//         toast.success("Subcategory updated successfully");
//       } else {
//         await api.post(`/subcategories`, payload);
//         toast.success("Subcategory added successfully");
//       }

//       resetForm();
//       fetchAll();
//     } catch (error) {
//       console.error("Save Subcategory Error:", error);
//       toast.error("Failed to save subcategory");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const openDeleteModal = (id) => {
//     setDeleteId(id);
//     setDeleteModalShow(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteId(null);
//     setDeleteModalShow(false);
//   };

//   const confirmDelete = async () => {
//     try {
//       await api.delete(`/subcategories/${deleteId}`);
//       toast.success("Subcategory deleted successfully");
//       closeDeleteModal();
//       fetchAll();
//     } catch (error) {
//       console.error("Delete Subcategory Error:", error);
//       toast.error("Failed to delete subcategory");
//     }
//   };

//   const clearFilters = () => {
//     setSearchTerm("");
//     setFilterUnit("");
//     setFilterCategory("");
//   };

//   const exportCSV = () => {
//     if (!filteredData.length) {
//       toast.warning("No data available to export");
//       return;
//     }

//     const headers = [
//       "ID",
//       "Name",
//       "Category",
//       "Description",
//       "Staff",
//       "Turnaround Time",
//     ];

//     const rows = filteredData.map((sub) => [
//       sub.id,
//       sub.name,
//       sub.category_name || categoryMap[String(sub.category_id)] || "",
//       sub.description,
//       sub.staff?.map((s) => s.name).join(", ") || "",
//       `${sub.tat_value || ""} ${sub.tat_unit || ""}`,
//     ]);

//     const csvContent = [headers, ...rows]
//       .map((row) =>
//         row
//           .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
//           .join(",")
//       )
//       .join("\n");

//     const blob = new Blob([csvContent], {
//       type: "text/csv;charset=utf-8;",
//     });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");

//     link.href = url;
//     link.download = "subcategories.csv";
//     link.click();

//     URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="unit-page subcategory-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>SubCategory Management</h2>
//           <p>
//             Manage subcategories with category mapping, staff assignment and
//             turnaround time.
//           </p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchAll}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
//             <i className="fa-solid fa-file-export" aria-hidden="true"></i>
//             Export CSV
//           </Button>

//           <Can moduleKey="subcategories" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAddModal}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Subcategory
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="subcategory-stat-icon subcategory-stat-icon-primary">
//             <i className="fa-solid fa-layer-group" aria-hidden="true"></i>
//           </div>
//           <div className="subcategory-stat-text">
//             <span>Total Subcategories</span>
//             <strong>{data.length}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="subcategory-stat-icon subcategory-stat-icon-accent">
//             <i className="fa-solid fa-filter" aria-hidden="true"></i>
//           </div>
//           <div className="subcategory-stat-text">
//             <span>Filtered Result</span>
//             <strong>{filteredData.length}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="subcategory-stat-icon subcategory-stat-icon-success">
//             <i className="fa-solid fa-list-ol" aria-hidden="true"></i>
//           </div>
//           <div className="subcategory-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-layer-group subcategory-list-icon" aria-hidden="true"></i>
//               SubCategory List
//             </h5>
//             <p>View, search, filter, add, update and delete subcategories.</p>
//           </div>

//           <div className="unit-toolbar-actions">
//             <InputGroup className="unit-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>

//               <Form.Control
//                 placeholder="Search name, category, staff..."
//                 aria-label="Search name, category, staff"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />

//               {searchTerm && (
//                 <Button
//                   className="unit-clear-btn"
//                   onClick={() => setSearchTerm("")}
//                   aria-label="Clear search"
//                 >
//                   Clear
//                 </Button>
//               )}
//             </InputGroup>

//             <Form.Select
//               className="unit-page-size subcategory-unit-filter"
//               aria-label="Filter by unit"
//               value={filterUnit}
//               onChange={(e) => setFilterUnit(e.target.value)}
//             >
//               <option value="">All Units</option>
//               {units.map((unit) => (
//                 <option key={unit.id} value={unit.id}>
//                   {unit.name}
//                 </option>
//               ))}
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size subcategory-category-filter"
//               aria-label="Filter by category"
//               value={filterCategory}
//               onChange={(e) => setFilterCategory(e.target.value)}
//             >
//               <option value="">All Categories</option>
//               {allCategories.map((cat) => (
//                 <option key={cat.id} value={cat.id}>
//                   {cat.name}
//                 </option>
//               ))}
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               aria-label="Rows per page"
//               value={itemsPerPage}
//               onChange={(e) => setItemsPerPage(Number(e.target.value))}
//             >
//               <option value={5}>5 rows</option>
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>

//             {(searchTerm || filterUnit || filterCategory) && (
//               <Button className="unit-btn unit-btn-light" onClick={clearFilters}>
//                 Reset
//               </Button>
//             )}
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading subcategories...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th
//                     className="sortable"
//                     onClick={() => handleSort("name")}
//                   >
//                     Subcategory {getSortIcon("name")}
//                   </th>

//                   <th
//                     className="sortable"
//                     onClick={() => handleSort("category")}
//                   >
//                     Category {getSortIcon("category")}
//                   </th>

//                   <th>Description</th>
//                   <th>Staff</th>

//                   <th className="sortable" onClick={() => handleSort("tat")}>
//                     Turnaround Time {getSortIcon("tat")}
//                   </th>

//                   <th className="text-end" style={{ width: "130px" }}>
//                     Actions
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {paginatedData.length > 0 ? (
//                   paginatedData.map((sub) => (
//                     <tr key={sub.id}>
//                       <td>
//                         <div className="unit-name-box">
//                           <div className="unit-letter">
//                             {sub.name?.charAt(0)?.toUpperCase() || "S"}
//                           </div>

//                           <div>
//                             <strong>{sub.name}</strong>
//                             <small>Subcategory ID: {sub.id}</small>
//                           </div>
//                         </div>
//                       </td>

//                       <td>
//                         <Badge className="unit-status">
//                           {sub.category_name ||
//                             categoryMap[String(sub.category_id)] ||
//                             "-"}
//                         </Badge>
//                       </td>

//                       <td>{sub.description || "-"}</td>

//                       <td>
//                         {sub.staff?.length
//                           ? sub.staff.map((s) => s.name).join(", ")
//                           : "-"}
//                       </td>

//                       <td>
//                         <span className="unit-id">
//                           {sub.tat_value || 0} {sub.tat_unit || "days"}
//                         </span>
//                       </td>

//                       <td>
//                         <div className="unit-actions">
//                           <Can moduleKey="subcategories" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label={`Edit ${sub.name || "subcategory"}`}
//                               onClick={() => handleEdit(sub)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           <Can moduleKey="subcategories" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Delete"
//                               aria-label={`Delete ${sub.name || "subcategory"}`}
//                               onClick={() => openDeleteModal(sub.id)}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="6">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-layer-group" aria-hidden="true"></i>
//                         </div>
//                         <h5>No subcategories found</h5>
//                         <p>Try another keyword or add a new subcategory.</p>

//                         <Button
//                           className="unit-btn unit-btn-primary"
//                           onClick={openAddModal}
//                         >
//                           <i className="fa-solid fa-plus" aria-hidden="true"></i>
//                           Add Subcategory
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing{" "}
//             <strong>{filteredData.length === 0 ? 0 : indexOfFirst + 1}</strong>{" "}
//             to <strong>{Math.min(indexOfLast, filteredData.length)}</strong> of{" "}
//             <strong>{filteredData.length}</strong> entries
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((prev) => prev - 1)}
//               />

//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item
//                   key={i + 1}
//                   active={i + 1 === currentPage}
//                   onClick={() => setCurrentPage(i + 1)}
//                 >
//                   {i + 1}
//                 </Pagination.Item>
//               ))}

//               <Pagination.Next
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((prev) => prev + 1)}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={modalShow}
//         onHide={resetForm}
//         backdrop="static"
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {editId ? "Edit Subcategory" : "Add New Subcategory"}
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Form.Group className="mb-3">
//             <Form.Label>Subcategory Name</Form.Label>
//             <Form.Control
//               placeholder="Enter subcategory name"
//               value={form.name}
//               onChange={(e) => handleChange("name", e.target.value)}
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Description</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               placeholder="Enter description"
//               value={form.description}
//               onChange={(e) => handleChange("description", e.target.value)}
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Unit</Form.Label>
//             <Form.Select
//               value={form.unit_id}
//               onChange={(e) => {
//                 const unitId = e.target.value;

//                 setForm({
//                   ...form,
//                   unit_id: unitId,
//                   category_id: "",
//                   staff_ids: [],
//                 });

//                 filterCategoriesByUnit(unitId);
//                 filterStaffByUnit(unitId);
//               }}
//             >
//               <option value="">Select Unit</option>
//               {units.map((unit) => (
//                 <option key={unit.id} value={unit.id}>
//                   {unit.name}
//                 </option>
//               ))}
//             </Form.Select>
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Category</Form.Label>
//             <Form.Select
//               value={form.category_id}
//               onChange={(e) => handleChange("category_id", e.target.value)}
//             >
//               <option value="">Select Category</option>
//               {categories.map((cat) => (
//                 <option key={cat.id} value={cat.id}>
//                   {cat.name}
//                 </option>
//               ))}
//             </Form.Select>
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Staff</Form.Label>
//             <Select
//               isMulti
//               options={filteredStaff.map((user) => ({
//                 value: String(user.id),
//                 label: user.name || user.username || `User #${user.id}`,
//               }))}
//               value={filteredStaff
//                 .filter((user) => form.staff_ids.includes(String(user.id)))
//                 .map((user) => ({
//                   value: String(user.id),
//                   label: user.name || user.username || `User #${user.id}`,
//                 }))}
//               onChange={(selectedOptions) => {
//                 const selectedIds = selectedOptions.map((option) => option.value);
//                 handleChange("staff_ids", selectedIds);
//               }}
//             />
//           </Form.Group>

//           <Form.Group>
//             <Form.Label>Turnaround Time</Form.Label>
//             <InputGroup>
//               <Form.Control
//                 type="number"
//                 placeholder="Enter value"
//                 value={form.tat_value}
//                 onChange={(e) => handleChange("tat_value", e.target.value)}
//               />

//               <Form.Select
//                 value={form.tat_unit}
//                 onChange={(e) => handleChange("tat_unit", e.target.value)}
//               >
//                 <option value="days">Days</option>
//                 <option value="hours">Hours</option>
//               </Form.Select>
//             </InputGroup>
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={resetForm}>
//             Cancel
//           </Button>

//           <Button
//             className="unit-btn unit-btn-primary"
//             onClick={handleSave}
//             disabled={saving}
//           >
//             {saving
//               ? "Saving..."
//               : editId
//               ? "Update Subcategory"
//               : "Create Subcategory"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={deleteModalShow}
//         onHide={closeDeleteModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Subcategory</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <p className="unit-delete-text">
//             Are you sure you want to delete this subcategory? This action cannot
//             be undone.
//           </p>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
//             Cancel
//           </Button>

//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }




import React, { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import api from "../../api";
import {
  Table,
  Button,
  Modal,
  Form,
  InputGroup,
  Pagination,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import Can from "../../components/Can";
import "./SubCategory.css";

const initialForm = {
  name: "",
  description: "",
  unit_id: "",
  category_id: "",
  staff_ids: [],
  // "none" | "defined" -- a Subcategory legitimately may have no default
  // TAT at all (tat_value/tat_unit both NULL); Own Ticket/Raise Complaint
  // then require a per-task manual TAT instead (see
  // services/subcategoryTatService.js). Defaults to "none" so a new
  // Subcategory is never silently given a TAT nobody chose.
  tat_mode: "none",
  tat_value: "",
  tat_unit: "",
};

// "technician" -> "Technician", "data-analyst" -> "Data Analyst". Same
// convention as pages/admins/Category.js's Assigned User/Technician picker.
const roleLabelFor = (roleName) =>
  (roleName || "")
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const staffOptionLabel = (user) => {
  const name = user.name || user.username || `User #${user.id}`;
  const roleLabel = roleLabelFor(user.role_name);
  return [name, roleLabel, `#${user.id}`, user.email].filter(Boolean).join(" — ");
};

// Purely presentational: a stable color swatch per category so the list is
// easier to visually scan. Derived only from the category id/name already on
// the row -- no new data, no change to category mapping logic.
const CATEGORY_COLOR_CLASSES = [
  "subcategory-cat-c0",
  "subcategory-cat-c1",
  "subcategory-cat-c2",
  "subcategory-cat-c3",
  "subcategory-cat-c4",
  "subcategory-cat-c5",
];

const categoryColorClassFor = (key) => {
  const str = String(key ?? "");
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return CATEGORY_COLOR_CLASSES[hash % CATEGORY_COLOR_CLASSES.length];
};

// Purely presentational SLA-style severity tier for the Turnaround Time
// badge, derived only from the existing tat_value/tat_unit fields -- does
// not change how TAT is calculated, validated or saved.
const slaTierFor = (value, unit) => {
  if (value == null || !unit) return "neutral";
  const hours = unit === "days" ? Number(value) * 24 : Number(value);
  if (!Number.isFinite(hours)) return "neutral";
  if (hours <= 4) return "success";
  if (hours <= 24) return "warning";
  return "danger";
};

export default function AdminSubCategoryPage() {
  const [data, setData] = useState([]);
  const [units, setUnits] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [filteredStaff, setFilteredStaff] = useState([]);

  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [modalShow, setModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [filterUnit, setFilterUnit] = useState("");
  const [filterCategory, setFilterCategory] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    fetchAll();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterUnit, filterCategory, itemsPerPage]);

  const fetchAll = async () => {
    try {
      setLoading(true);

      const [unitsRes, catsRes, staffRes, subsRes] = await Promise.all([
        api.get(`/units`),
        api.get(`/categories`),
        // Subcategory Staff eligibility spans Technician, Developer and
        // Data Analyst (opt-in ?roles= on the existing endpoint -- see
        // userController.getTechnicianUsers / the same allowlist Category
        // assignment uses), matching the Category-level picker.
        api.get(`/technician-users?roles=technician,developer,data-analyst`),
        api.get(`/subcategories`),
      ]);

      setUnits(Array.isArray(unitsRes.data) ? unitsRes.data : []);
      setAllCategories(Array.isArray(catsRes.data) ? catsRes.data : []);
      setStaffList(Array.isArray(staffRes.data) ? staffRes.data : []);
      setData(Array.isArray(subsRes.data) ? subsRes.data : []);
    } catch (error) {
      console.error("Fetch Subcategory Error:", error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const unitMap = useMemo(() => {
    return Object.fromEntries(units.map((unit) => [String(unit.id), unit.name]));
  }, [units]);

  const categoryMap = useMemo(() => {
    return Object.fromEntries(
      allCategories.map((cat) => [String(cat.id), cat.name])
    );
  }, [allCategories]);

  const categoryUnitMap = useMemo(() => {
    return Object.fromEntries(
      allCategories.map((cat) => [String(cat.id), cat.unit_id])
    );
  }, [allCategories]);

  const filterCategoriesByUnit = (unitId) => {
    const filtered = allCategories.filter(
      (cat) => String(cat.unit_id) === String(unitId)
    );
    setCategories(filtered);
  };

  const filterStaffByUnit = (unitId) => {
    const filtered = staffList.filter(
      (user) => String(user.unit_id) === String(unitId)
    );
    setFilteredStaff(filtered);
  };

  const filteredData = useMemo(() => {
    let list = [...data];

    if (searchTerm.trim()) {
      const q = searchTerm.toLowerCase();

      list = list.filter((sub) => {
        const staffNames = sub.staff?.map((s) => s.name).join(" ") || "";
        const categoryName =
          sub.category_name || categoryMap[String(sub.category_id)] || "";

        return [
          sub.id,
          sub.name,
          sub.description,
          categoryName,
          staffNames,
          sub.tat_value,
          sub.tat_unit,
        ]
          .map((value) => (value ?? "").toString().toLowerCase())
          .join(" ")
          .includes(q);
      });
    }

    if (filterCategory) {
      list = list.filter(
        (sub) => String(sub.category_id) === String(filterCategory)
      );
    }

    if (filterUnit) {
      list = list.filter((sub) => {
        const unitId =
          sub.unit_id || categoryUnitMap[String(sub.category_id)] || "";
        return String(unitId) === String(filterUnit);
      });
    }

    list.sort((a, b) => {
      let valueA = "";
      let valueB = "";

      if (sortField === "category") {
        valueA = a.category_name || categoryMap[String(a.category_id)] || "";
        valueB = b.category_name || categoryMap[String(b.category_id)] || "";
      } else if (sortField === "tat") {
        valueA = Number(a.tat_value || 0);
        valueB = Number(b.tat_value || 0);
      } else {
        valueA = a[sortField] ?? "";
        valueB = b[sortField] ?? "";
      }

      valueA = valueA.toString().toLowerCase();
      valueB = valueB.toString().toLowerCase();

      if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
      if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

    return list;
  }, [
    data,
    searchTerm,
    filterUnit,
    filterCategory,
    categoryMap,
    categoryUnitMap,
    sortField,
    sortOrder,
  ]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const paginatedData = filteredData.slice(indexOfFirst, indexOfLast);

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return "↕";
    return sortOrder === "asc" ? "↑" : "↓";
  };

  const validateForm = () => {
    if (!form.name.trim()) {
      toast.warn("Subcategory name is required");
      return false;
    }

    if (!form.unit_id) {
      toast.warn("Please select unit");
      return false;
    }

    if (!form.category_id) {
      toast.warn("Please select category");
      return false;
    }

    if (!form.staff_ids.length) {
      toast.warn("Please select at least one staff");
      return false;
    }

    if (form.tat_mode === "defined") {
      if (!form.tat_value || Number(form.tat_value) <= 0) {
        toast.warn("Please enter a positive turnaround time value");
        return false;
      }
      if (!["hours", "days"].includes(form.tat_unit)) {
        toast.warn("Please select a valid turnaround time unit");
        return false;
      }
    }

    return true;
  };

  const openAddModal = () => {
    setForm(initialForm);
    setCategories([]);
    setFilteredStaff([]);
    setEditId(null);
    setModalShow(true);
  };

  const handleEdit = (row) => {
    const selectedCategory = allCategories.find(
      (cat) => String(cat.id) === String(row.category_id)
    );

    const selectedUnitId =
      row.unit_id || selectedCategory?.unit_id || "";

    setForm({
      name: row.name || "",
      description: row.description || "",
      unit_id: selectedUnitId,
      category_id: row.category_id || "",
      staff_ids: row.staff?.map((s) => String(s.id)) || [],
      tat_mode: row.tat_value != null && row.tat_unit ? "defined" : "none",
      tat_value: row.tat_value || "",
      tat_unit: row.tat_unit || "",
    });

    filterCategoriesByUnit(selectedUnitId);
    filterStaffByUnit(selectedUnitId);

    setEditId(row.id);
    setModalShow(true);
  };

  const resetForm = () => {
    setForm(initialForm);
    setCategories([]);
    setFilteredStaff([]);
    setEditId(null);
    setModalShow(false);
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      setSaving(true);

      const payload = {
        name: form.name.trim(),
        description: form.description.trim(),
        unit_id: Number(form.unit_id),
        category_id: Number(form.category_id),
        staff_ids: form.staff_ids.map((id) => Number(id)),
        // "No Default TAT" persists real NULLs, never 0/empty-string --
        // the backend (subcategoryController.js) independently re-derives
        // and validates this from tat_mode-equivalent input regardless.
        tat_value: form.tat_mode === "defined" ? Number(form.tat_value) : null,
        tat_unit: form.tat_mode === "defined" ? form.tat_unit : null,
      };

      if (editId) {
        await api.put(`/subcategories/${editId}`, payload);
        toast.success("Subcategory updated successfully");
      } else {
        await api.post(`/subcategories`, payload);
        toast.success("Subcategory added successfully");
      }

      resetForm();
      fetchAll();
    } catch (error) {
      console.error("Save Subcategory Error:", error);
      toast.error("Failed to save subcategory");
    } finally {
      setSaving(false);
    }
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setDeleteModalShow(true);
  };

  const closeDeleteModal = () => {
    setDeleteId(null);
    setDeleteModalShow(false);
  };

  const confirmDelete = async () => {
    try {
      await api.delete(`/subcategories/${deleteId}`);
      toast.success("Subcategory deleted successfully");
      closeDeleteModal();
      fetchAll();
    } catch (error) {
      console.error("Delete Subcategory Error:", error);
      // 409 SUBCATEGORY_IN_USE: tickets still use it -- show why.
      const data = error?.response?.data || {};
      toast.error(data.message || data.error || "Failed to delete subcategory");
    }
  };

  const clearFilters = () => {
    setSearchTerm("");
    setFilterUnit("");
    setFilterCategory("");
  };

  const exportCSV = () => {
    if (!filteredData.length) {
      toast.warning("No data available to export");
      return;
    }

    const headers = [
      "ID",
      "Name",
      "Category",
      "Description",
      "Staff",
      "Turnaround Time",
    ];

    const rows = filteredData.map((sub) => [
      sub.id,
      sub.name,
      sub.category_name || categoryMap[String(sub.category_id)] || "",
      sub.description,
      sub.staff?.map((s) => s.name).join(", ") || "",
      `${sub.tat_value || ""} ${sub.tat_unit || ""}`,
    ]);

    const csvContent = [headers, ...rows]
      .map((row) =>
        row
          .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
          .join(",")
      )
      .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "subcategories.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <div className="unit-page subcategory-mgmt-theme">

      <div className="subcategory-heading-box">
        <div className="subcategory-heading-content">
          <div className="subcategory-heading-icon">
            <i className="fa-solid fa-layer-group" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>SubCategory Management</h2>
            <p>
              Manage subcategories with category mapping, staff assignment and
              turnaround time.
            </p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchAll}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
            <i className="fa-solid fa-file-export" aria-hidden="true"></i>
            Export CSV
          </Button>

          <Can moduleKey="subcategories" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openAddModal}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Subcategory
            </Button>
          </Can>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card subcategory-stat-blue">
          <div className="subcategory-stat-content">
            <div className="subcategory-stat-text">
              <span>Total Subcategories</span>
              <strong>{data.length}</strong>
            </div>

            <div className="subcategory-stat-icon">
              <i className="fa-solid fa-layer-group" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card subcategory-stat-purple">
          <div className="subcategory-stat-content">
            <div className="subcategory-stat-text">
              <span>Filtered Result</span>
              <strong>{filteredData.length}</strong>
            </div>

            <div className="subcategory-stat-icon">
              <i className="fa-solid fa-filter" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card subcategory-stat-green">
          <div className="subcategory-stat-content">
            <div className="subcategory-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="subcategory-stat-icon">
              <i className="fa-solid fa-list-ol" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="subcategory-section-title">
            <div className="subcategory-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div>
              <h5>SubCategory List</h5>
              <p>View, search, filter, add, update and delete subcategories.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions">
            <InputGroup className="unit-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>

              <Form.Control
                placeholder="Search name, category, staff..."
                aria-label="Search name, category, staff"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              {searchTerm && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => setSearchTerm("")}
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <Form.Select
              className="unit-page-size subcategory-unit-filter"
              aria-label="Filter by unit"
              value={filterUnit}
              onChange={(e) => setFilterUnit(e.target.value)}
            >
              <option value="">All Units</option>
              {units.map((unit) => (
                <option key={unit.id} value={unit.id}>
                  {unit.name}
                </option>
              ))}
            </Form.Select>

            <Form.Select
              className="unit-page-size subcategory-category-filter"
              aria-label="Filter by category"
              value={filterCategory}
              onChange={(e) => setFilterCategory(e.target.value)}
            >
              <option value="">All Categories</option>
              {allCategories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </Form.Select>

            <Form.Select
              className="unit-page-size"
              aria-label="Rows per page"
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>

            {(searchTerm || filterUnit || filterCategory) && (
              <Button className="unit-btn unit-btn-light" onClick={clearFilters}>
                <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
                Reset
              </Button>
            )}
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading subcategories...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th
                    className="sortable"
                    onClick={() => handleSort("name")}
                  >
                    Subcategory {getSortIcon("name")}
                  </th>

                  <th
                    className="sortable"
                    onClick={() => handleSort("category")}
                  >
                    Category {getSortIcon("category")}
                  </th>

                  <th>Description</th>
                  <th>Staff</th>

                  <th className="sortable" onClick={() => handleSort("tat")}>
                    Turnaround Time {getSortIcon("tat")}
                  </th>

                  <th className="text-end" style={{ width: "130px" }}>
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((sub) => {
                    const categoryName =
                      sub.category_name ||
                      categoryMap[String(sub.category_id)] ||
                      "-";
                    const catColorClass = categoryColorClassFor(sub.category_id);
                    const tatTier = slaTierFor(sub.tat_value, sub.tat_unit);
                    const visibleStaff = sub.staff?.slice(0, 2) || [];
                    const extraStaffCount = (sub.staff?.length || 0) - visibleStaff.length;

                    return (
                      <tr key={sub.id}>
                        <td>
                          <div className="unit-name-box">
                            <div className="unit-letter">
                              {sub.name?.charAt(0)?.toUpperCase() || "S"}
                            </div>

                            <div>
                              <strong>{sub.name}</strong>
                              <small>Subcategory ID: {sub.id}</small>
                            </div>
                          </div>
                        </td>

                        <td>
                          <span className={`subcategory-category-badge ${catColorClass}`}>
                            <span className="subcategory-category-dot" aria-hidden="true"></span>
                            {categoryName}
                          </span>
                        </td>

                        <td>
                          <span
                            className="subcategory-desc-clamp"
                            title={sub.description || ""}
                          >
                            {sub.description || "-"}
                          </span>
                        </td>

                        <td>
                          {visibleStaff.length ? (
                            <div className="subcategory-staff-wrap">
                              {visibleStaff.map((s) => (
                                <span className="subcategory-staff-chip" key={s.id}>
                                  <i className="fa-regular fa-user" aria-hidden="true"></i>
                                  {s.name}
                                </span>
                              ))}

                              {extraStaffCount > 0 && (
                                <span
                                  className="subcategory-staff-chip subcategory-staff-more"
                                  title={sub.staff
                                    .slice(2)
                                    .map((s) => s.name)
                                    .join(", ")}
                                >
                                  +{extraStaffCount}
                                </span>
                              )}
                            </div>
                          ) : (
                            "-"
                          )}
                        </td>

                        <td>
                          <span className={`subcategory-tat-chip subcategory-tat-${tatTier}`}>
                            <i className="fa-regular fa-clock" aria-hidden="true"></i>
                            {sub.tat_value != null && sub.tat_unit
                              ? `${sub.tat_value} ${sub.tat_unit}`
                              : "No Default TAT"}
                          </span>
                        </td>

                        <td>
                          <div className="unit-actions">
                            <Can moduleKey="subcategories" actionKey="edit">
                              <Button
                                className="unit-icon-btn unit-edit"
                                title="Edit"
                                aria-label={`Edit ${sub.name || "subcategory"}`}
                                onClick={() => handleEdit(sub)}
                              >
                                <i className="fa-solid fa-pen" aria-hidden="true"></i>
                              </Button>
                            </Can>

                            <Can moduleKey="subcategories" actionKey="delete">
                              <Button
                                className="unit-icon-btn unit-delete"
                                title="Delete"
                                aria-label={`Delete ${sub.name || "subcategory"}`}
                                onClick={() => openDeleteModal(sub.id)}
                              >
                                <i className="fa-solid fa-trash" aria-hidden="true"></i>
                              </Button>
                            </Can>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-layer-group" aria-hidden="true"></i>
                        </div>
                        <h5>No subcategories found</h5>
                        <p>Try another keyword or add a new subcategory.</p>

                        <Button
                          className="unit-btn unit-btn-primary"
                          onClick={openAddModal}
                        >
                          <i className="fa-solid fa-plus" aria-hidden="true"></i>
                          Add Subcategory
                        </Button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing{" "}
            <strong>{filteredData.length === 0 ? 0 : indexOfFirst + 1}</strong>{" "}
            to <strong>{Math.min(indexOfLast, filteredData.length)}</strong> of{" "}
            <strong>{filteredData.length}</strong> entries
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
              />

              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i + 1}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}

              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
              />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={modalShow}
        onHide={resetForm}
        backdrop="static"
        centered
        className="unit-modal"
        dialogClassName="admin-teal-modal subcategory-mgmt-theme subcategory-drawer"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <i
            className={
              (editId ? "fa-solid fa-pen-to-square" : "fa-solid fa-layer-group") +
              " modal-header-icon"
            }
            aria-hidden="true"
          ></i>
          <Modal.Title>
            {editId ? "Edit Subcategory" : "Add New Subcategory"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Subcategory Name</Form.Label>
            <Form.Control
              placeholder="Enter subcategory name"
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter description"
              value={form.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </Form.Group>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Unit</Form.Label>
                <Form.Select
                  value={form.unit_id}
                  onChange={(e) => {
                    const unitId = e.target.value;

                    setForm({
                      ...form,
                      unit_id: unitId,
                      category_id: "",
                      staff_ids: [],
                    });

                    filterCategoriesByUnit(unitId);
                    filterStaffByUnit(unitId);
                  }}
                >
                  <option value="">Select Unit</option>
                  {units.map((unit) => (
                    <option key={unit.id} value={unit.id}>
                      {unit.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Category</Form.Label>
                <Form.Select
                  value={form.category_id}
                  onChange={(e) => handleChange("category_id", e.target.value)}
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Staff</Form.Label>
            <Select
              isMulti
              className="subcategory-react-select"
              classNamePrefix="subcategory-select"
              placeholder="Select technician, developer or data analyst..."
              options={filteredStaff.map((user) => ({
                value: String(user.id),
                label: staffOptionLabel(user),
              }))}
              value={filteredStaff
                .filter((user) => form.staff_ids.includes(String(user.id)))
                .map((user) => ({
                  value: String(user.id),
                  label: staffOptionLabel(user),
                }))}
              onChange={(selectedOptions) => {
                const selectedIds = selectedOptions.map((option) => option.value);
                handleChange("staff_ids", selectedIds);
              }}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Turnaround Time</Form.Label>
            {/* Single controlled source of truth: form.tat_mode ("none" |
                "defined"). Each option is a native radio wrapped in its own
                <label>, so clicking the circle, the text, OR anywhere else
                in the card all activate the SAME element the browser
                already associates the click with -- no separate onClick on
                the wrapper (which would double-fire alongside the label's
                native behavior) and no defaultChecked/uncontrolled state. */}
            <div className="subcategory-tat-mode-group">
              <label
                className={`subcategory-tat-mode-card${form.tat_mode === "none" ? " subcategory-tat-mode-card-selected" : ""}`}
              >
                <input
                  type="radio"
                  name="tat_mode"
                  value="none"
                  checked={form.tat_mode === "none"}
                  onChange={() =>
                    setForm((prev) => ({ ...prev, tat_mode: "none", tat_value: "", tat_unit: "" }))
                  }
                />
                <span>No Default TAT</span>
              </label>
              <label
                className={`subcategory-tat-mode-card${form.tat_mode === "defined" ? " subcategory-tat-mode-card-selected" : ""}`}
              >
                <input
                  type="radio"
                  name="tat_mode"
                  value="defined"
                  checked={form.tat_mode === "defined"}
                  onChange={() => handleChange("tat_mode", "defined")}
                />
                <span>Define TAT</span>
              </label>
            </div>

            {form.tat_mode === "defined" ? (
              <InputGroup className="mt-2">
                <Form.Control
                  type="number"
                  min="1"
                  placeholder="TAT Value"
                  value={form.tat_value}
                  onChange={(e) => handleChange("tat_value", e.target.value)}
                />

                <Form.Select
                  value={form.tat_unit}
                  onChange={(e) => handleChange("tat_unit", e.target.value)}
                >
                  <option value="" disabled>Select unit</option>
                  <option value="hours">Hours</option>
                  <option value="days">Days</option>
                </Form.Select>
              </InputGroup>
            ) : (
              <Form.Text className="text-muted d-block mt-2">
                Developer/Data Analyst Own Tickets and Complaints for this Subcategory will require a TAT to be entered per task.
              </Form.Text>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={resetForm}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Subcategory" : "Create Subcategory"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={deleteModalShow}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger subcategory-mgmt-theme"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <i className="fa-solid fa-trash modal-header-icon" aria-hidden="true"></i>
          <Modal.Title>Delete Subcategory</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="unit-delete-text">
            Are you sure you want to delete this subcategory? This action cannot
            be undone.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}